import { Stack } from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import i18next from 'i18next';
import React, { memo } from 'react';
import { useRef } from 'react';
import { useMemo } from 'react';
import { useEffect } from 'react';

const deepInjectSelect = (children, Select, index) => {
  return React.Children.map(
    children,
    (child, childIndex) => {
      if (!React.isValidElement(child)) {
        return child;
      }

      const newProps = { Select: Select === index };

      if (child.props.children) {
        newProps.children = deepInjectSelect(
          child.props.children,
          Select,
          index
        );
      }

      return React.cloneElement(child, newProps);
    }
  );
};

const Radioaizer = ({
  direction = 'row',
  elements,
  initialFunction,
  onSelectFunction,
  justPassSelect = false,
  fullWidth = false,
  defaultSelectIndex,
  resetWatcher,
  rows = '1fr 1fr 1fr 1fr 1fr',
  cols = '1fr 1fr 1fr 1fr 1fr',
  gridgap = '.5em',
  styles = {},
  justifyContent = 'space-between',
}) => {

 
  const isEnglish = i18next.language === 'en';

  const initialRender = useRef(true);
  const [Select, setSelect] = React.useState(
    defaultSelectIndex
  );
  const [resetter, setResetter] = React.useState(false);
  initialFunction && initialFunction(setSelect, elements);
  React.useEffect(() => {
    if (!initialRender.current && Select !== undefined) {
      onSelectFunction &&
        !resetter &&
        onSelectFunction(
          Select,
          setSelect,
          elements,
          elements[Select]
        );
    } else {
      initialRender.current = false;
    }
  }, [Select]);
  useEffect(() => {
    setSelect(defaultSelectIndex);
  }, [defaultSelectIndex]);
  useEffect(() => {
    if (resetWatcher) {
      setResetter(true);
    }
  }, [resetWatcher]);
  useMemo(() => {
    if (resetter) {
      setSelect();
      setTimeout(() => {
        setResetter(false);
      }, 100);
    }
  }, [resetter]);
  return (
    <React.Fragment>
      <Stack
        direction={direction}
        justifyContent={justifyContent}
        gap={1}
        sx={{
          ...(direction === 'grid'
            ? {
                display: 'grid',
                gridTemplateColumns: rows,
                gridTemplateRows: cols,
                gap: gridgap,
                direction: !isEnglish ? 'rtl' : '',
              }
            : {}),
          ...styles,
        }}
      >
        {elements?.map((element, index) => (
          <span
            onClick={() => setSelect(index)}
            key={index}
            style={
              !justPassSelect
                ? {
                    cursor: 'pointer',
                    border:
                      Select === index && '1px solid blue',
                    borderRadius: '5px',
                  }
                : { width: '100% !important' }
            }
          >
            {justPassSelect
              ? deepInjectSelect(element, Select, index)
              : element}
          </span>
        ))}
      </Stack>
    </React.Fragment>
  );
};

export default memo(Radioaizer);
